<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    title="编辑图片"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="图片标题"
        :label-width="formLabelWidth"
        prop="userName"
      >
        <el-input v-model="editForm.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="楼盘图片"
        :label-width="formLabelWidth"
        prop="classify"
      >
        <!-- 图片上传 -->
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :before-upload="beforeAvatarUpload"
          drag
          multiple
          list-type="picture"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="排序"
        :label-width="formLabelWidth"
        prop="create_people"
      >
        <el-input
          v-model="editForm.create_people"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="副标题"
        :label-width="formLabelWidth"
        prop="create_people"
      >
        <el-input
          v-model="editForm.create_people"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="户型面积"
        :label-width="formLabelWidth"
        prop="create_people"
      >
        <el-input
          v-model="editForm.create_people"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <div class="switch">
        <el-form-item
          label="是否开启"
          :label-width="formLabelWidth"
          prop="create_people"
        >
          <el-switch
            v-model="value"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitedit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formData, formRules } from '../form';

export default {
  name: 'addHousePic',
  data() {
    return {
      formLabelWidth: '100px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: { ...formData }, // 编辑表单
      editRules: formRules, // 表单的验证规则
      fileList: [
        {
          name: 'food.jpg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        },
        {
          name: 'food2.jpg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        },
      ], // 上传图片组
      action: '', // 上传图片的地址
      value: '', // 开关
    };
  },
  methods: {
    // 删除图片
    handleRemove(file, fileList) {
      window.console.log(file, fileList);
    },

    // 上传图片
    handlePreview(file) {
      window.console.log(file);
    },

    // 上传图片前验证规则
    beforeAvatarUpload(file) {
      // console.log('上传图片：', file);
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      //const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      /*  if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M */
      return isJPG;
    },

    submitedit() {
      this.$refs.editForm.validate((valid) => {
        window.console.log(valid);
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.switch {
  display: flex;
}
</style>
